import React, { useContext, useRef } from 'react';
import { useFormikContext, useField } from 'formik';
import { getAsterisk } from '../Form/ErrorLabel';
import { AccountPanelTypes } from '../../AccountPanelTypes';
import { UpdatePaymentContext } from '../context/updatePaymentContext';
import { ExistingCardTypeIcon } from '../PayRent/CardTypeIcon';

export const CardNumberField = ({ fieldname, label, ...props }: any) => {
  const [field] = useField(props);
  const { setFieldValue } = useFormikContext<
    AccountPanelTypes.TCardDetailsFormInitialValues
  >();
  const cardNumberFieldRef = useRef<null | HTMLInputElement>(null);
  const updatePaymentContext = useContext(UpdatePaymentContext);

  const cardNumberFormatter = (cardNumber: string) => {
    const cardNumberWithStarts = cardNumber.includes('X')
      ? cardNumber
      : cardNumber.replaceAll('x', 'X');
    const cardNumberWithSlash = cardNumberWithStarts.includes('-')
      ? cardNumberWithStarts
      : cardNumberWithStarts.match(/.{1,4}/g)?.join('-');
    return cardNumberWithSlash;
  };

  return (
    <div className="cardNumberInputFieldSection">
      <label className="formInputFieldLabel">
        {label}
        {getAsterisk()}
      </label>
      <input
        ref={cardNumberFieldRef}
        className="formInputField"
        id="cardNumberField"
        placeholder="XXXX-XXXX-XXXX-XXXX"
        type="text"
        {...field}
        {...props}
        onChange={e => {
          const regex = new RegExp('[^0-9-]+');
          const inNumber = e.target.value;
          if (!regex.test(inNumber)) {
            const formattedInput = cardNumberFormatter(e.target.value);
            setFieldValue(fieldname, formattedInput);
          }
        }}
      />
      {updatePaymentContext.cardType && (
        <ExistingCardTypeIcon cardType={updatePaymentContext.cardType} />
      )}
    </div>
  );
};
